import type { AudioMediaDataModel } from "../../app/contexts/audio.context";
import type { Api } from "../../../services/api";
import type { ArticleDetail } from "../../../features/article/hooks/useArticleData";

type ArticleListItem =
  Api["get"]["/webapp/public/articles"]["output"]["body"]["docs"][number];

type ArticleAudioSource = ArticleDetail | ArticleListItem;

export function convertArticleToMediaData(
  source: ArticleAudioSource,
  trackUrl: string
): AudioMediaDataModel {
  return {
    source,
    type: "article_audio",
    title: source.title,
    imageUrl: "",
    trackUrl,
  };
}
